export const LOGIN_SUCCESS = "login-success";
export const LOGOUT_REQUEST = "logout-request";
export const UPDATE_USER = "UPDATE_USER";
export const SET_PERSONAL_DATA = "SET_PERSONAL_DATA";
export const SETTING_ACTIVE_TAB = "SET_ACTIVE_TAB";
